<template>
  <TextFieldInput
    ref="txtQr"
    :label="$t('ELE0213')"
    v-model="model"
    prependIcon="mdi-qrcode"
    autofocus
    isQRField
    :required="required"
    @blur="scanned"
    maxLength="200"
  />
</template>

<script>
import { API } from '@/plugins/api'
import APIUtils from '@/mixin/api-utils.js'
import Message from '@/mixin/message-utils.js'
import Loading from '@/mixin/loading-utils.js'

import TextFieldInput from '@/components/atoms/base/text-field/TextFieldInput'

export default {
  name: 'InspLotQRCodeInput',

  mixins: [APIUtils, Message, Loading],
  components: { TextFieldInput },

  props: {
    value: {
      type: [String],
      default: '',
      required: true,
    },
    disabled: {
      type: Boolean,
      default: false,
      required: false,
    },
    required: {
      type: Boolean,
      default: false,
      required: false,
    },
    label: {
      type: String,
      required: false,
      default: function () {
        return this.$t('ELE0213')
      },
    },
  },

  data() {
    return {
      lastScanedValue: '',
    }
  },

  computed: {
    model: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit('input', value ? value : '')
      },
    },
  },

  methods: {
    async scanned() {
      // 空文字列・前回と同じ値を読ませない処理
      if (!this.model) {
        return
      }
      if (this.model == this.lastScanedValue) {
        this.$refs.txtQr.focus()
        return
      }
      this.lastScanedValue = this.model

      try {
        this.startLoading()

        const elements = await API.get('/box/inspLots/qr', {
          qrCode: this.model,
        })

        this.$emit('scanned', elements)
      } catch (error) {
        this.setErrorMessage(this.resolveErrorMessage(error, this.$t('MSG0002', { p0: this.$t('ELE0118') })))
      } finally {
        this.stopLoading()
        this.$refs.txtQr.focus()
      }
    },
    focus() {
      this.$refs.txtQr.focus()
    },
  },
}
</script>
